export const getBlotNode = (
  node: HTMLElement
): { node: HTMLElement; id: string } | null => {
  if (node.classList && node.classList.contains('blot-pic')) {
    return {
      node,
      id: node.id.replace('blot_', ''),
    }
  }

  if (node.parentNode) {
    return getBlotNode(node.parentNode as HTMLElement)
  }

  return null
}

export const isMatterLink = (
  node: HTMLElement
): { id: string; type: string; href: string } | null => {
  const type = node.getAttribute('type') as string
  if (
    node.tagName === 'A' &&
    ['matter', 'people', 'img', 'file'].includes(type)
  ) {
    return {
      id: node.getAttribute('data-id') as string,
      type,
      href: node.getAttribute('href') as string,
    }
  }

  if (node.parentNode?.nodeName !== 'BODY') {
    return isMatterLink(node.parentNode as HTMLElement)
  }

  return null
}

export const getLoadingDom = (node: HTMLElement) => {
  const container = node.querySelector('span')
  const loadingDom = document.createElement('img')
  loadingDom.classList.add('loading')
  loadingDom.src = './images/loading.gif'
  container?.appendChild(loadingDom)
  container?.removeChild(node.querySelector('.fail-dom') as Node)
}
